import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { Buffer } from 'buffer';
import App from './App.jsx';
import { NearProvider } from './contexts/NearContext.jsx';
import './index.css';

// Expose Buffer for near-api-js utilities that expect the Node global in browsers
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <NearProvider>
          <App />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </NearProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
